import {
  SET_ERROR,
  REMOVE_ERROR,
  // TODO: import action types added later
} from './types'

function setError(errorObject) {
  return {
    type: SET_ERROR,
    payload: {
      errorObject,
    },
  }
}

function removeError(errorName) {
  return {
    type: REMOVE_ERROR,
    payload: {
      errorName,
    },
  }
}

// TODO: add more action creators

export {
  setError,
  removeError,
  // TODO: export action creators added later
}
